import CheckboxBase from '@/global/components/Form/Base/Checkbox'
import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

const mensagemDefault = `Parabéns pelo seu aniversário! 🎉🎈🎂 
Aproveite seu dia ao máximo, com risadas, diversão e, quem sabe, 
um cochilo de leve depois do almoço. 😴`

export default function OutrosDados() {
    const { watch, setValue } = useFormContext()
    const mensagem = watch('mensagemAniversario')

    const [enviarMensagem, setEnviarMensagem] = useState(!!mensagem)

    return (
        <section id="dados-cadastrais">
            <Grid container spacing={2}>
                <Grid item xs={12} className="flex flex-row items-center">
                    <CheckboxBase
                        checked={enviarMensagem}
                        onChange={() =>
                            setEnviarMensagem(prev => {
                                if (!prev) {
                                    setValue(
                                        'mensagemAniversario',
                                        mensagemDefault,
                                    )
                                    return true
                                }
                                setValue('mensagemAniversario', '')
                                return false
                            })
                        }
                    >
                        Enviar notificação no aniversário de cada colaborador
                        <IconeAjuda>
                            <p>
                                Ao ativar essa opção, será enviada uma mensagem
                                de parabéns no aniversário de cada colaborador.
                            </p>
                            <p>A notificação será exibida no aplicativo.</p>
                        </IconeAjuda>
                    </CheckboxBase>
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="mensagemAniversario"
                        label="Mensagem"
                        rows={5}
                        multiline
                        disabled={!enviarMensagem}
                        max={250}
                    />
                </Grid>
                <Grid item xs={12} className="flex flex-row items-center">
                    <FormFieldCheckbox
                        name="ocultarInfoRodapeEspelho"
                        label="Reduzir informações do rodapé do espelho"
                    />
                    <IconeAjuda>
                        <span>
                            <span>
                                Quando habilitado, os seguintes dados do rodapé
                                do espelho do ponto serão ocultados:
                            </span>
                            <br />
                            <br />
                            <ul style={{ marginLeft: '20px' }}>
                                <li>Saldo anterior</li>
                                <li>Saldo atual</li>
                                <li>Saldo da competência</li>
                                <li>Horas a trabalhar</li>
                                <li>Horas trabalhadas</li>
                                <li>Faltas integrais</li>
                                <li>Faltas parciais</li>
                                <li>Desconto do DSR</li>
                            </ul>
                        </span>
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}
